import React from "react";
import { connect } from "react-redux";
import { HorizontalLoader } from "../../widgets/Loader";
import { ScreenOverlay } from "../../widgets";

const SavingOverlay = ({ show }) =>
    <ScreenOverlay show={show}>
        <ScreenOverlay.Content>
            <ScreenOverlay.Text>Saving...</ScreenOverlay.Text>
            <HorizontalLoader />
        </ScreenOverlay.Content>
    </ScreenOverlay>;

const mapStateToProps = state => ({
    show: state.egKanban.isRequestingSave
});

export default connect(mapStateToProps)(SavingOverlay);